import { useTX } from '@transifex/react';
import { ChevronDown } from 'lucide-react';
import { Form, useLocation, useSubmit } from 'react-router';
import { Button } from '~/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '~/components/ui/dropdown-menu';
import { ampli } from '~/third-party/ampli/.client';
import { defaultLanguage, LANGUAGES } from '~/lib/languages';

export function NavbarLanguageSwitcher() {
  const tx = useTX();
  const locale = tx.getCurrentLocale();
  const location = useLocation();
  const submit = useSubmit();

  function handleLangChange(lang: string) {
    ampli.selectLanguage({ language: lang });
    submit(
      { lang, next: location.pathname + location.search },
      { method: 'post', action: '/lang', replace: true }
    );
  }

  return (
    <Form method="post" action="/lang" replace className="contents">
      <input type="hidden" name="next" value={location.pathname + location.search} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" type="button" className="gap-xs">
            <span>
              {LANGUAGES.find(l => l.code === locale)?.shortLabel || defaultLanguage.shortLabel}
            </span>
            <ChevronDown className="size-5 text-primary-300" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuRadioGroup value={locale} onValueChange={handleLangChange}>
            {LANGUAGES.map(lang => (
              <DropdownMenuRadioItem key={lang.code} value={lang.code}>
                {lang.label}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </Form>
  );
}
